var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "14px",
    viewBox: "0 0 20 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gumb-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    transform: "translate(-745.000000, -825.000000)",
    fill: "#859599",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(530.000000, 750.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Youtube",
    transform: "translate(213.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5970696,7.1875 C21.76801,7.84375 21.8901099,8.84027759 21.96337,10.1770833 L22,12 L21.96337,13.8229167 C21.8901099,15.1840276 21.76801,16.1927083 21.5970696,16.8489583 C21.4749697,17.2621526 21.2551894,17.6267359 20.9377289,17.9427083 C20.6202684,18.2586807 20.2417582,18.4774307 19.8021978,18.5989583 C19.1672774,18.7690974 17.6776557,18.890625 15.3333333,18.9635417 L12,19 L8.66666667,18.9635417 C6.32234432,18.890625 4.83272265,18.7690974 4.1978022,18.5989583 C3.75824176,18.4774307 3.37973157,18.2586807 3.06227106,17.9427083 C2.74481056,17.6267359 2.52503034,17.2621526 2.4029304,16.8489583 C2.23199005,16.1927083 2.10989011,15.1840276 2.03663004,13.8229167 L2,12 C2,11.4652776 2.01220983,10.8576391 2.03663004,10.1770833 C2.10989011,8.84027759 2.23199005,7.84375 2.4029304,7.1875 C2.52503034,6.75 2.74481056,6.37326407 3.06227106,6.05729167 C3.37973157,5.74131926 3.75824176,5.52256926 4.1978022,5.40104167 C4.83272265,5.23090259 6.32234432,5.109375 8.66666667,5.03645833 L12,5 L15.3333333,5.03645833 C17.6776557,5.109375 19.1672774,5.23090259 19.8021978,5.40104167 C20.2417582,5.52256926 20.6202684,5.74131926 20.9377289,6.05729167 C21.2551894,6.37326407 21.4749697,6.75 21.5970696,7.1875 Z M10,15 L15,11.9815951 L10,9 L10,15 Z",
    id: "\\uF167"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.35d15c58.svg";
export { ForwardRef as ReactComponent };